import { Navigate, useOutletContext } from "react-router";
import { href } from "../../lib/utils";

const pwa = window.matchMedia("(display-mode: standalone)").matches;
const ios = navigator.userAgent.match(/(iPad|iPhone|iPod)/g);

export const Home = () => {
	const { accounts, initialSelectedAccount } = useOutletContext<any>();

	if (Object.keys(accounts).length < 1) {
		return <Navigate to="/login" />;
	} else {
		const accountId =
			initialSelectedAccount &&
			Object.keys(accounts).includes(initialSelectedAccount || "")
				? initialSelectedAccount
				: Object.keys(accounts)[0];
		return <Navigate to={href("/accounts/:accountId", { accountId })} />;
	}
};
